@if (!isWorkflowConfigTypesLoading()) {
    <form [formGroup]="workflowConfigFormGroup()" class="grid grid-cols-1 gap-4">
        <sag-ui-autocomplete
            formControlName="type"
            [label]="'workflow.workflow-config-details.workflow-type' | translate"
            [placeholder]="'workflow.workflow-config-details.search-workflow-types' | translate"
            [ariaDescribedby]="'workflow.workflow-config-details.search-workflow-types' | translate"
        >
            @for (
                workflowConfigDetailsTranslationRecord of WORKFLOW_CONFIG_TYPES_TRANSLATIONS_RECORD;
                track workflowConfigDetailsTranslationRecord.label
            ) {
                <sag-ui-autocomplete-option [value]="workflowConfigDetailsTranslationRecord.value">
                    {{ workflowConfigDetailsTranslationRecord.label | translate }}
                </sag-ui-autocomplete-option>
            }
        </sag-ui-autocomplete>
        @if (workflowTypes()?.length !== 0) {
            <sag-ui-autocomplete
                formControlName="id"
                [label]="'workflow.workflow-config-details.workflow-name' | translate"
                [placeholder]="'workflow.workflow-config-details.search-workflow-names' | translate"
                [ariaDescribedby]="'workflow.workflow-config-details.search-workflow-names' | translate"
            >
                @for (workflow of sortedWorkflowTypes(); track workflow.id) {
                    <sag-ui-autocomplete-option [value]="workflow.id"
                        >{{ workflow.name | translate }}
                    </sag-ui-autocomplete-option>
                }
            </sag-ui-autocomplete>
        } @else {
            <div class="flex items-end justify-center text-light-tooltipError dark:text-dark-tooltipError h-full">
                {{ 'workflow.workflow-config-details.config-error' | translate }}
            </div>
        }
    </form>
} @else {
    <app-workflow-config-details-skeleton />
}
